// This is the list of all 10 sexual health & reproduction articles
// Used to display cards on the frontend and know which letter to send when viewing

export const articlesList = [
  {
    letter: "A1",
    title: "Understanding the Effects of Aging on Sexual Function"
  },
  {
    letter: "C1",
    title: "Common Mistakes to Avoid During Ovulation"
  },
  {
    letter: "C2",
    title: "Why Do Some Men Release Sperm Faster? A Guide to Ejaculation"
  },
  {
    letter: "F1",
    title: "Fuel Your Fertility: Foods That Help You Conceive"
  },
  {
    letter: "S1",
    title: "The 5 Key Pillars of Sexual Health"
  },
  {
    letter: "S2",
    title: "Tips for Maintaining Good Sexual Health"
  },
  {
    letter: "S3",
    title: "Common Sexual Health Issues Affecting Men and Women"
  },
  {
    letter: "S4",
    title: "Building Stronger Sexual Communication and Closeness with Your Partner"
  },
  {
    letter: "M1",
    title: "How Mental Health Affects Sexual Function and Well-Being"
  },
  {
    letter: "W1",
    title: "Intimacy Hacks, Explained: What Actually Helps You Get Closer"
  }
];